import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, IconButton, Typography, Stack, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NewClientForm from '../sections/NewClientForm';
import { getUserGroups } from '../utils';
import { LightTooltip } from '../components/custom-components/custom-tooltip';
import PageBreadcrumbs from '../components/common/PageBreadcrumbs';

export default function NewClientPage() {
  const navigate = useNavigate();
  useEffect(() => {
    const userGroups = getUserGroups();
    if (!userGroups || (!userGroups.includes('admin') && !userGroups.includes('associate'))) {
      navigate('/login', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <title>BillerBay | New Client</title>
      </Helmet>

      <Grid container spacing={3}>
        <Grid item xs={12} md={2} lg={3} />
        <Grid item xs={12} md={8} lg={6}>
          <PageBreadcrumbs
            items={[
              { label: 'Admin', href: '/dashboard' },
              { label: 'Client', href: '/clients' },
              { label: 'New Client' },
            ]}
          />
          <Stack direction="row" alignItems="flex-start" spacing={1} sx={{ mb: 3 }}>
            <LightTooltip title="Return to the client directory without saving." placement="right">
              <IconButton onClick={() => navigate('/clients')} aria-label="Back to clients list" edge="start">
                <ArrowBackIcon />
              </IconButton>
            </LightTooltip>
            <Box sx={{ pt: 0.25 }}>
              <Typography variant="h4" component="h1">
                Onboard new client
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: 520, lineHeight: 1.65 }}>
                Add a practice to your directory. After you submit, the client receives sign-in instructions at the
                primary email address.
              </Typography>
            </Box>
          </Stack>

          <NewClientForm />
        </Grid>
        <Grid item xs={12} md={2} lg={3} />
      </Grid>
    </>
  );
}
